import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";

import { addPopupDetailsFragment, addPopupFragment } from "./queries";
import { AddPopUpCreateDefault } from "./types/AddPopUpCreateDefault";
import {
  AddPopupReorderVariants,
  AddPopupReorderVariantsVariables
} from "./types/AddPopupReorderVariants";
import {
  AddPopupUpdate,
  AddPopupUpdateVariables
} from "./types/AddPopupUpdate";
import {
  AddPopupVariants,
  AddPopupVariantsVariables
} from "./types/AddPopupVariants";
import {
  AddPopupVariantsRemove,
  AddPopupVariantsRemoveVariables
} from "./types/AddPopupVariantsRemove";

const addPopupCreateDefault = gql`
  ${addPopupFragment}
  mutation AddPopUpCreateDefault {
    addpopupCreateDefault {
      addpopup {
        ...AddPopupFragment
      }
      errors {
        field
        message
      }
    }
  }
`;

export const useAddPopupCreateDefaultMutation = makeMutation<
  AddPopUpCreateDefault,
  null
>(addPopupCreateDefault);

const addPopupUpdate = gql`
  ${addPopupFragment}
  mutation AddPopupUpdate($id: ID!, $input: AddPopupInput!) {
    addpopupUpdate(id: $id, input: $input) {
      addpopup {
        ...AddPopupFragment
      }
      errors {
        field
        message
      }
    }
  }
`;

export const useAddPopupUpdateMutation = makeMutation<
  AddPopupUpdate,
  AddPopupUpdateVariables
>(addPopupUpdate);

const addPopupVariantsRemove = gql`
  ${addPopupDetailsFragment}
  mutation AddPopupVariantsRemove($input: VariantInput!, $id: ID!) {
    addpopupRemoveVariants(id: $id, input: $input) {
      errors {
        field
        message
      }
      addpopup {
        ...AddPopupDetailsFragment
      }
    }
  }
`;

export const useAddPopupVariantsRemoveMutation = makeMutation<
  AddPopupVariantsRemove,
  AddPopupVariantsRemoveVariables
>(addPopupVariantsRemove);

const addPopupVariants = gql`
  ${addPopupDetailsFragment}
  mutation AddPopupVariants($input: VariantInput!, $id: ID!) {
    addpopupVariants(id: $id, input: $input) {
      errors {
        field
        message
      }
      addpopup {
        ...AddPopupDetailsFragment
      }
    }
  }
`;

export const useAddPopupVariantsMutation = makeMutation<
  AddPopupVariants,
  AddPopupVariantsVariables
>(addPopupVariants);

const addPopupReorderVariants = gql`
  ${addPopupDetailsFragment}
  mutation AddPopupReorderVariants(
    $move: MoveAddPopupVariantInput!
    $addpopupId: ID!
  ) {
    addpopupReorderVariants(moves: [$move], addpopupId: $addpopupId) {
      addpopup {
        ...AddPopupDetailsFragment
      }
      errors {
        field
        message
      }
    }
  }
`;

export const useAddPopupReorderVariants = makeMutation<
  AddPopupReorderVariants,
  AddPopupReorderVariantsVariables
>(addPopupReorderVariants);
